import { render, staticRenderFns } from "./b-loading-spinner.vue?vue&type=template&id=7a6c0107&scoped=true"
import script from "./b-loading-spinner.vue?vue&type=script&lang=js"
export * from "./b-loading-spinner.vue?vue&type=script&lang=js"
import style0 from "./b-loading-spinner.vue?vue&type=style&index=0&id=7a6c0107&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6c0107",
  null
  
)

export default component.exports